import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiUsersThree, PiMicrophoneStage } from 'react-icons/pi';
import { IColorProp } from 'types/components/components.interface';
import { ARTIST_TYPE } from 'types/artist/artist.interface';

export interface ILabeledStatusProps {
 status: ARTIST_TYPE;
}

interface ILabeledStatusParams extends IColorProp {
 status: ARTIST_TYPE;
 icon: ReactNode;
}

const labeledStatusParams: ILabeledStatusParams[] = [
 {
  status: ARTIST_TYPE.false,
  color: 'blue',
  icon: <PiMicrophoneStage />,
 },
 {
  status: ARTIST_TYPE.true,
  color: 'green',
  icon: <PiUsersThree />,
 },
];

const LabeledArtistType = ({ status }: ILabeledStatusProps) => {
 const { t } = useTranslation();
 const labeledParams =
  labeledStatusParams.find((params) => params.status === status) ??
  labeledStatusParams[0];
 return (
  <Label
   size="compact"
   color={labeledParams.color}
   title={t(`${labeledParams.status}`)}
  >
   {labeledParams.icon} {t(`enum.ARTISTS.${labeledParams.status}`)}
  </Label>
 );
};

export default LabeledArtistType;
